export const bubbleDialog = {
  intro: [
    {
      text: "Greetings and salutations! I'm your personal ChatGPT mixologist, your virtual buddy who's here to help you with cocktails! Meow 🍹",
      delay: 0,
    },
    {
      text: 'ChatGPT is a conversational AI developed by OpenAI. Meow 😻',
      delay: 7000,
    },
    {
      text: 'It uses deep learning to understand and generate human-like responses in natural language conversations. Meow 😼',
      delay: 4000,
    },
    {
      text: 'It can discuss various topics, but its answers may occasionally be inaccurate or nonsensical. So be careful. Meow 🙀',
      delay: 5500,
    },
    {
      text: 'Ready to mix up some magic? Use the KEYBOARD below and share the ingredients you have on hand! Meow 🍹😸',
      delay: 7000,
    },
  ],
  onFocus:
    'Ready to dive into the mixology madness? Check ingredient list and hit the "Beep Boop" button to submit, and we\'ll get the cocktail shenanigans started! Meow 😸',
  onLoading:
    'Just a moment, cocktail alchemy is in progress. Get ready to savor a delightful recommendation! It will take about a minute. Meow 💭',
  onSuccess:
    'Voila! Your recommendation is complete, served up with a side of digital flair! Check out the delightful recommendation. Cheers and enjoy! Meow 😻',
  onFailure:
    'Apologies, but it seems AI is currently out of power – please forgive the inconvenience! Try again later. Meow 😿',
}
